import { Grid, TextField } from "@material-ui/core";
import { usePackagePageContext } from "@providers/PackagePageProvider";
import React from "react";

function PackagePageSEO() {
  const { packagePage, setPackagePage } = usePackagePageContext();
  const handleChange = (e) => {
    setPackagePage({
      ...packagePage,
      [e.target.name]: e.target.value,
    });
  };
  return (
    <form noValidate autoComplete="off">
      <Grid container spacing={3} direction="column">
        <Grid item xs={4}>
          <TextField
            name="seoTitle"
            onChange={handleChange}
            value={packagePage.seoTitle || ""}
            fullWidth
            size="small"
            label="Title"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={7}>
          <TextField
            name="seoDescription"
            onChange={handleChange}
            value={packagePage.seoDescription || ""}
            fullWidth
            multiline
            size="small"
            minRows={3}
            maxRows={6}
            label="Description"
            variant="outlined"
          />
        </Grid>
      </Grid>
    </form>
  );
}

export default PackagePageSEO;
